export default "__VITE_ASSET__f86f2a7f__"